import { apiUrl, isNativePlatform } from './platform'
import { getAccessTokenSync } from './tokenStore'

// Central fetch wrapper. Resolves the API base URL and applies the correct auth
// transport for the platform:
//   web    → same-origin, HttpOnly cookies (credentials: 'include')
//   native → absolute URL to the remote BFF, X-Client-Type: mobile + Bearer token
//
// Higher-level concerns (CSRF for web, 401→refresh retry) live in authApi.
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
    const native = isNativePlatform()
    const headers: Record<string, string> = { ...(init.headers as Record<string, string> | undefined) }

    if (native) {
        headers['X-Client-Type'] = 'mobile'
        const token = getAccessTokenSync()
        if (token && !headers['Authorization']) {
            headers['Authorization'] = `Bearer ${token}`
        }
    }

    const opts: RequestInit = { ...init, headers }
    // Cookies only matter for the same-origin web client.
    if (!native) opts.credentials = 'include'

    return fetch(apiUrl(path), opts)
}
